module.exports = __webpack_public_path__ + "static/media/owner.4516e85a.svg";